module.exports = __webpack_public_path__ + "img/espadin_1.40a670be.jpg";